import moneyBackIcon from "@/assets/icons/money-back-icon.svg";
import parse from "html-react-parser";

const DEFAULT_BADGE = {
  title: "30-Day Money Back Guarantee",
  description:
    "Feel safe knowing you are protected with a 30 days guarantee. Simply send the item(s) back in the original packaging to receive a full refund or replacement.",
};

const getBadgeData = () => {
  const base = typeof window !== "undefined" ? window?.post_template?.checkout_v4_moneyback_badge : null;

  return {
    image: base?.checkout_v4_moneyback_badge_image || moneyBackIcon,
    title: base?.tr_checkout_v4_moneyback_badge_title || DEFAULT_BADGE.title,
    description: base?.tr_checkout_v4_moneyback_badge_description || DEFAULT_BADGE.description,
  };
};

const styles = {
  container: {
    display: "flex",
    padding: "16px",
    alignItems: "flex-start",
    gap: "16px",
    alignSelf: "stretch",
    borderRadius: "6px",
    border: "1px solid #E0E0E0",
    background: "#F5F5F5",
    marginBottom: "24px",
  },
  iconWrapper: {
    width: "64px",
    height: "64px",
    aspectRatio: "1/1",
    flexShrink: 0,
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  heading: {
    color: "#000",
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
    margin: "0 0 4px 0",
  },
  paragraph: {
    color: "#3C3C3C",
    fontFamily: "Roboto, sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    margin: 0,
  },
};

const MoneyBadge = () => {
  const { image, title, description } = getBadgeData();

  return (
    <div style={styles.container}>
      <div style={styles.iconWrapper}>
        <img src={image} alt={title} style={styles.image} />
      </div>
      <div>
        <h3 style={styles.heading}>{title}</h3>
        <div style={styles.paragraph}>{parse(description)}</div>
      </div>
    </div>
  );
};

export default MoneyBadge;
